import initStore from './initStore';
import actions from './actions';
import thunks from './thunks';

import { IProgramsModel } from './types';

const programs: IProgramsModel = {
  ...initStore,
  ...actions,
  ...thunks,
};

export default programs;
